import { Navigation, Pagination, Autoplay } from "swiper/modules";
import Swiper from "swiper";

class CustomSwiper {
    constructor() {
        this.list = [];
        this.init();
    }

    init() {
        const sliders = document.querySelectorAll(".highligts-slider");

        if (!sliders.length) return;

        sliders.forEach((element) => {
            const slider = element.querySelector(".swiper");
            const prevEl = element.querySelector(".slider-nav__item_prev");
            const nextEl = element.querySelector(".slider-nav__item_next");
            const paginationEl = element.querySelector(".slider-pagination");

            if (!slider) return;

            const totalRealSlides = slider.querySelectorAll(".swiper-slide").length;

            const swiperInstance = new Swiper(slider, {
                modules: [Navigation, Pagination, Autoplay],

                slidesPerView: 1.2,
                slidesPerGroup: 1,
                spaceBetween: 16,

                slidesOffsetBefore: 0,
                slidesOffsetAfter: 0,

                speed: 600,
                loop: true,
                loopedSlides: totalRealSlides,

                centeredSlides: false,

                observer: true,
                watchOverflow: false,
                watchSlidesProgress: true,

                pagination: {
                    el: paginationEl,
                    type: "bullets",
                    clickable: true,
                    bulletClass: "slider-pagination__item",
                    bulletActiveClass: "active",
                    modifierClass: "slider-pagination--"
                },

                on: {
                    init: function () {
                        updateNav(this, prevEl, nextEl, totalRealSlides);
                    },
                    slideChange: function () {
                        updateNav(this, prevEl, nextEl, totalRealSlides);
                    },
                    touchStart: function () {
                        this.el.classList.add("is-grabbing");
                    },
                    touchEnd: function () {
                        this.el.classList.remove("is-grabbing");
                    }
                },

                breakpoints: {
                    575: {
                        slidesPerView: 1.7,
                        spaceBetween: 16,
                    },
                     768: {
                        slidesPerView: 2.7,
                        spaceBetween: 16,
                    },
                    992: {
                        slidesPerView: 3.5,
                        spaceBetween: 16,
                    },
                    1240: {
                        slidesPerView: 3.5,
                        spaceBetween: 30,
                    },
                    1600: {
                        slidesPerView: 4,
                        spaceBetween: 30
                    },
                    1730: {
                        slidesPerView: 5,
                        spaceBetween: 30
                    },
                    3000: {
                        slidesPerView: 6,
                        spaceBetween: 30
                    }
                }
            });

            prevEl.addEventListener("click", () => {
                swiperInstance.slidePrev();
            });

            nextEl.addEventListener("click", () => {
                swiperInstance.slideNext();
            });

            this.list.push(swiperInstance);
        });
    }
}

function updateNav(swiper, prevEl, nextEl, totalRealSlides) {
    const realIndex = swiper.realIndex;

    if (realIndex === 0) {
        prevEl.classList.add("disabled");
    } else {
        prevEl.classList.remove("disabled");
    }

    if (realIndex === totalRealSlides - 1) {
        nextEl.classList.add("disabled");
    } else {
        nextEl.classList.remove("disabled");
    }
}

export default CustomSwiper;
